import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19dc551f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-intro" }, "Interested in working together? Get in touch.", -1))
const _hoisted_3 = {
  key: 0,
  class: "success-message"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Thanks for reaching out! I'll get back to you soon.", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "error-message"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contact-name" }, "Name", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contact-email" }, "Email", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contact-message" }, "Message", -1))
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
        ]))
      : (_openBlock(), _createElementBlock("form", {
          key: 2,
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          class: "form-fields"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              id: "contact-name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              type: "text",
              placeholder: "Your name",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              id: "contact-email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              placeholder: "you@example.com",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("textarea", {
              id: "contact-message",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message) = $event)),
              rows: "5",
              placeholder: "Tell me about your project or idea...",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.message]
            ])
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "submit-btn",
            disabled: _ctx.submitting
          }, _toDisplayString(_ctx.submitting ? 'Sending...' : 'Send Message'), 9, _hoisted_13)
        ], 32))
  ]))
}